<div class="options-board-widget">
	<app-options-board [widget]="widget()" />
</div>
